import React from "react";
import { ContentBody } from 'areas/shared/components';
import { Box } from "fw/components";
import Search from './Search';
import CompanyInfoTab from './CompanyInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as APIModules from 'modules/app/API';
import * as App from 'modules/app/App';
import API from 'fw/system/API';
import * as Formatter from 'fw/components/formatter/Formatter';
import queryString from 'query-string';

class ConnectToVOB extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            list: [],
            loading: false
        };
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
    }
    
    onExecutiveReportSummary = (rq) => {
        new API().post(APIModules.Admin.url('/certification/searchConnectVOBExecutiveReportExport', rq), rq,
            {
                success: (sr) => {
                    new API().download(sr.data);
                }
            });
    }

    render() {
        let opts = {
            setupKey: "companySetup",
            title: "Search for Veteran Owned Business",
            enableColumnSettings: true,
            recentType: "connectToVOB",
            customAction: App.hasPrivilege("ExecutiveReportSummaryConnect") ? { title: 'Executive Report Summary', onExecute: this.onExecutiveReportSummary } : null,
            enableExport: true,
            showTitle: false,
            showButtons: {
                cancel: false,
                save: false
            },
            list: {
                url: APIModules.Admin.url('/certification/searchConnectVOB'),
                rowKey: "certificationId",
                columns: [
                    { key: 'vobName', name: 'Company Name', width: 190, sortable: true },
					{ key: 'dbaName', name: 'DBA Name', width: 190, sortable: true },
                    { key: 'veteranOwner', name: 'Veteran Name', width: 190, sortable: true },
                    { key: 'naicsCodes', name: 'NAICS Code(s)', sortable: false },
                    { key: 'stateCode', name: 'State', width: 62, sortable: true },
                    { key: 'geographicMarketName', name: 'Geo Market', width: 100, sortable: true },
                    { key: 'employees', name: 'Employees', width: 97, sortable: true },
                    { key: 'sdvs', name: 'SDVS', width: 62, sortable: true },
                    { key: 'certificationStatusDescription', name: 'Status', width: 72, sortable: true },
                    { key: 'revenue', name: 'Revenue', width: 92, formatter: Formatter.CurrencyWithoutDecimals, sortable: true },
                    { key: 'businessOwnershipName', name: 'Ownership', width: 125, sortable: true },
                ]
            },
            tabs: [
                { key: "companyInfo", title: "Company Info", comp: CompanyInfoTab }
            ]
        };

        const params = queryString.parse(this.props.location.search);
        const triggerInitialSearch = Object.keys(params).length > 0;

        return (
            <React.Fragment>
                <ContentBody>
                    <Box>
                        <SetupPage {...opts} Search={Search} triggerInitialSearch={triggerInitialSearch} />
                    </Box>
                </ContentBody>
            </React.Fragment >
        );
    }
}

export default ConnectToVOB;



// WEBPACK FOOTER //
// ./src/areas/admin/connectToVOB/ConnectToVOB.js